import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

// BILL-3055: amplia el allowlist para tablas y encabezados Markdown, que hoy quedaban recortados por DOMPurify.
const ALLOWED_TAGS = [
  'p', 'strong', 'em', 'ul', 'ol', 'li', 'code', 'pre', 'a', 'br', 'blockquote',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'del',
  'table', 'thead', 'tbody', 'tr', 'th', 'td'
];
const ALLOWED_ATTR = ['href'];

// BILL-3055: registrado una sola vez a nivel de modulo, no en el constructor de la clase
// (que se re-instancia en cada TestBed de Karma y re-agregaba el mismo hook al DOMPurify
// global en cada test).
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

@Injectable({ providedIn: 'root' })
export class MarkdownRenderService {

  constructor(private readonly sanitizer: DomSanitizer) {}

  toSanitizedHtml(markdown: string): string {
    // BILL-3055: breaks:true — el backend hoy manda texto plano con \n simples; sin esto colapsan al desplegar Fase A sola.
    const rawHtml = marked.parse(markdown, { async: false, breaks: true }) as string;
    // BILL-3055: ALLOW_DATA_ATTR:false — endurece el allowlist, nada legitimo en el chat usa atributos data-*.
    // BILL-3055: ALLOW_ARIA_ATTR:false — mismo criterio que ALLOW_DATA_ATTR, nada legitimo en el chat usa aria-* y el contenido viene de un LLM/KB.
    return DOMPurify.sanitize(rawHtml, { ALLOWED_TAGS, ALLOWED_ATTR, ALLOW_DATA_ATTR: false, ALLOW_ARIA_ATTR: false });
  }

  toSafeHtml(markdown: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.toSanitizedHtml(markdown));
  }
}
